function ActiveUsers() {
  return (
    <svg width={22} height={40} viewBox="0 0 22 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.719 38.438c0 .086.07.156.156.156h7.5a.156.156 0 100-.313h-7.5a.156.156 0 00-.156.157zM10 1.719h3.125a.156.156 0 100-.313H10a.156.156 0 100 .313zM13.906 1.719a.156.156 0 100-.313.156.156 0 000 .313z"
        fill="#2C2C2C"
      />
      <path
        d="M18.125 0h-15A3.134 3.134 0 000 3.125v27.53c.175-.445.385-.875.625-1.287V3.125c0-1.378 1.122-2.5 2.5-2.5h2.034c0 .026.544 1.014.544 1.014.37.656.938 1.017 1.601 1.017h6.608c.76 0 1.542-.445 1.782-1.014 0 0 .4-.985.393-1.017h2.038c1.378 0 2.5 1.122 2.5 2.5v26.243c.24.412.45.842.625 1.288V3.125A3.134 3.134 0 0018.125 0zm-2.72 1.52c-.187.447-.871.824-1.493.824H7.304c-.699 0-1.108-.467-1.328-.858L5.492.625h10.292l-.378.895z"
        fill="#2C2C2C"
      />
      <path
        d="M14.421 25.388a5.62 5.62 0 01-.597.483c3.9.902 6.801 4.184 6.801 8.086v4.653c0 .63-.135.765-.762.765H1.387c-.627 0-.762-.136-.762-.765v-4.653c0-3.902 2.9-7.184 6.801-8.086a5.645 5.645 0 01-.597-.483C3.012 26.481 0 29.774 0 33.957v4.653C0 39.584.415 40 1.387 40h18.476c.972 0 1.387-.416 1.387-1.39v-4.653c0-4.183-3.012-7.476-6.829-8.569z"
        fill="#2C2C2C"
      />
      <path
        d="M15.625 21.25a5 5 0 10-6.004 4.899l-1.01 5.088c-.068.324.08.739.323.929l1.216 1.268a.81.81 0 00.98-.014l1.184-1.24a.99.99 0 00.32-.944l-1.206-5.056a4.997 4.997 0 004.197-4.93zM12.33 31.31c.052.207-.044.494-.226.64l-1.185 1.239c-.156.123-.419.123-.559.014l-1.216-1.268a.715.715 0 01-.228-.636l1.014-5.103c.228.032.459.054.695.054.166 0 .33-.01.492-.025l1.213 5.085zm-1.705-5.685A4.38 4.38 0 016.25 21.25a4.38 4.38 0 014.375-4.375A4.38 4.38 0 0115 21.251a4.38 4.38 0 01-4.375 4.374z"
        fill="#2C2C2C"
      />
    </svg>
  );
}

export default ActiveUsers;
